import { useAuth0 } from "@auth0/auth0-react";
import { ca } from "date-fns/locale";
// export async function GetAccessToken(setAccessToken, currentAccessToken) {
//   const { getAccessTokenSilently } = useAuth0();

//   const audience = 'https://piaapplication.azurewebsites.net/';

//   const accessToken = await getAccessTokenSilently({
//     audience: audience,
//     //scope: "read:messages",
//   }).then(data => {
//     //debugger;
//     if (setAccessToken!==null && currentAccessToken===false) {
//       //if (setAccessToken!==null ) {
//       setAccessToken('Bearer ' + data);
//     }
//    // console.log(btoa(data));
//     return ('Bearer ' + data);
//   });

//   return accessToken;
// };
export async function GetAccessToken() {
  //setAccessToken(JSON.stringify(localStorage.getItem("userToken")));
  return JSON.stringify(localStorage.getItem("userToken"));
};
export async function fetcher(args) {
  // debugger;
  // if (!args[1]) { //avoid unauth error if token not retrieved
  //   return; 
  //   var response = await fetch(args[0], {
  //     method: 'GET'
  //   }
  //   );
  //   var data = await response.json();

  //   return data;
  // }
  try {
    var response = await fetch(args[0], {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': localStorage.getItem("userToken"),
        'Content-Type': 'application/json'
      }
    }
    ).then((response) => {
      if (response.ok) {
        return response.json();
      }

      if (response.status === 401) {
        //alert("Session expired. Please log in again.");
        localStorage.removeItem("userToken");
        window.location.href = "/manuallogin";
      }
      return response;
    }
    )
  } catch (error) {
    console.error("An error occurred:", error);
  }
  return response;
}